import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Aprende from "@/pages/Aprende";
import Subject from "@/pages/Subject";
import Lesson from "@/pages/Lesson";
import Noticiero from "@/pages/Noticiero";
import Article from "@/pages/Article";
import Login from "@/pages/Login";
import Admin from "@/pages/admin/Admin";
import LessonEditor from "@/pages/admin/LessonEditor";
import ArticleEditor from "@/pages/admin/ArticleEditor";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/aprende" element={<Aprende />} />
              <Route path="/aprende/:subject" element={<Subject />} />
              <Route path="/aprende/:subject/:id" element={<Lesson />} />
              <Route path="/noticiero" element={<Noticiero />} />
              <Route path="/noticiero/:id" element={<Article />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/admin/leccion/:id" element={<ProtectedRoute><LessonEditor /></ProtectedRoute>} />
              <Route path="/admin/articulo/:id" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
            </Routes>
          </Layout>
          <Toaster position="top-right" theme="light" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
